// ==============================|| AUTH HOOKS ||============================== //
import { useContext } from "react";

import AuthContext, { AuthContextType } from "contexts/AuthContext";

const useAuth = () => {
  const context: AuthContextType = useContext(AuthContext);

  if (!context) throw new Error("context must be use inside provider");

  return context;
};

export default useAuth;
